var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sub-visual overflow-hidden"
  }, [_c('v-container', [this.$slots['titleContents'] ? [_vm._t("titleContents")] : _c('h2', {
    staticClass: "font-size-30 font-size-md-60 font-size-lg-72 overflow-hidden"
  }, [_c('span', {
    attrs: {
      "data-aos": "fade",
      "data-aos-duration": "700"
    }
  }, [_vm._v(_vm._s(_vm.title))])])], 2), _vm.src ? _c('div', {
    staticClass: "sub-visual__img",
    style: 'background-image:url(' + _vm.src + ');',
    attrs: {
      "data-aos": "fade",
      "data-aos-duration": "1500"
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }